/**
 * Checking is Valid Required Period Of Dates relative to current date
 * @param {*} s - the slide object. Object format {component, datesShow: {start, end}}
 * @returns object ' { isValid: boolean, isExistDatesShow: boolean } ' if start and end date between current date, than return true, otherwise return false. 
 * if part of object ' datesShow: {start, end} ' not exist, return false.
 * 
 */
export function getDateRestriction(s) {
  let result = {
    isValid: false,
    isExistDatesShow: false
  }
  // Checking for exists dates for slide
  if (s.datesShow) {
    if (s.datesShow.start && s.datesShow.end) {

      const dateStart = new Date(s.datesShow.start).getTime()
      const dateEnd = new Date(s.datesShow.end).getTime()

      const isValidDateStart = isFinite(dateStart)
      const isValidDateEnd = isFinite(dateEnd)

      // Checking for correct type of dates
      if (isValidDateStart && isValidDateEnd) {
        result.isExistDatesShow = true;
        const currDate = Date.now()

        // Checking if start and end dates of slide is valid relative to current time
        if (dateStart <= currDate && currDate <= dateEnd) {
          result.isValid = true;
        }
      }
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/shared/core/impl/libs/getDateRestriction.js